import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `NivelGenetico`, method: 'GET', body: null, token: token})
}
